"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _ConnectionIndicator = require("./ConnectionIndicator");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TileConnection = function TileConnection(_ref) {
  var name = _ref.name,
    peerId = _ref.peerId,
    hideLabel = _ref.hideLabel,
    width = _ref.width;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
    children: [!hideLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      css: _objectSpread({
        c: "$textHighEmp"
      }, (0, _reactUi.textEllipsis)(width - 60)),
      variant: "xs",
      children: name
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConnectionIndicator.ConnectionIndicator, {
      isTile: true,
      peerId: peerId
    })]
  });
};
var Wrapper = (0, _reactUi.styled)("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "absolute",
  bottom: "$2",
  left: "$2",
  zIndex: 10,
  backgroundColor: "$backgroundDark",
  borderRadius: "$1",
  "& p,span": {
    p: "$2 $3"
  }
});
var _default = TileConnection;
exports["default"] = _default;